import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { INTEL_FUNDING_RATES_LAYOUT_ID, INTEL_FUNDING_RATES_LAYOUT_TEMPLATE_ID } from '../tokens';
import { INTEL_FUNDING_RATES_LAYOUT } from './IntelFundingRates';

export const INTEL_FUNDING_RATES_LAYOUT_SPEC: LayoutSpec = {
  templateId: INTEL_FUNDING_RATES_LAYOUT_TEMPLATE_ID,
  label: 'Funding Rates',
  id: INTEL_FUNDING_RATES_LAYOUT_ID,
  dockViewLayout: INTEL_FUNDING_RATES_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
